import React from 'react';
import ServicePageTemplate, { ALL_SERVICES } from './ServicePageTemplate';

const pageData = {
  seo: {
    title: 'CMS & Ecommerce Development Company | RojrzTech',
    description:
      'RojrzTech builds powerful CMS and ecommerce platforms — WordPress, Shopify, WooCommerce, custom solutions. Drive more sales with a stunning online store.',
  },
  hero: {
    badge: 'CMS & ECOMMERCE EXPERTS',
    slides: [
      {
        heading: { pre: 'Powerful', gold: 'CMS & Ecommerce', post: 'Solutions' },
        subheading:
          'Our web development company brings your content management systems and eCommerce store to life with a one-of-a-kind digital experience that sells.',
        pills: ['WordPress', 'Shopify', 'WooCommerce', 'Headless CMS'],
        image: '/CMS1.jpeg',
      },
      {
        heading: { pre: 'Sell More with', gold: 'Smart Ecommerce' },
        subheading:
          'Build an online store that converts visitors into customers. We design and develop ecommerce platforms that are fast, secure, and optimized for sales.',
        pills: ['Payment Gateway', 'Inventory', 'SEO', 'Analytics', 'Multi-currency'],
        image: '/CMS2.jpeg',
      },
      {
        heading: { pre: 'Custom CMS Built for', gold: 'Your Business' },
        subheading:
          'Take control of your content with a custom CMS tailored specifically to your workflow, team, and business requirements — no bloat, just what you need.',
        pills: ['Headless', 'API-driven', 'Scalable', 'Multi-site', 'Custom Fields'],
        image: '/CMS.jpeg',
      },
    ],
  },
  servicesCards: {
    title: 'Our Comprehensive CMS & Ecommerce Development Services',
    subtitle:
      'As one of the most in-demand CMS development agencies, we ensure your platform meets your unique needs. Here are the types of solutions we create:',
    cards: [
      {
        icon: '🛒',
        title: 'Custom Ecommerce Development',
        description:
          'Bespoke ecommerce platforms built from the ground up, designed for conversion, scale, and a seamless shopping experience.',
      },
      {
        icon: '🏪',
        title: 'Shopify & WooCommerce Development',
        description:
          'Expert Shopify and WooCommerce development — theme customization, plugin integration, and performance optimization for your store.',
      },
      {
        icon: '📝',
        title: 'WordPress CMS Development',
        description:
          'Custom WordPress development with bespoke themes and plugins. You get a fast, SEO-friendly, and easy-to-manage website.',
      },
      {
        icon: '🔗',
        title: 'Headless CMS Development',
        description:
          'Modern headless CMS architecture that decouples content from presentation, delivering blazing-fast experiences across all channels.',
      },
      {
        icon: '💳',
        title: 'Payment Gateway Integration',
        description:
          'Secure, PCI-compliant payment gateway integration — Stripe, PayPal, Razorpay, and more — making checkout smooth and safe.',
      },
      {
        icon: '📊',
        title: 'Ecommerce Analytics & Optimization',
        description:
          'Data-driven insights to optimize your store performance, reduce cart abandonment, and maximize your revenue streams.',
      },
    ],
  },
  features: {
    title: 'CMS & Ecommerce Development for Accelerated Business Growth',
    subtitle:
      'Develop custom ecommerce solutions that enhance your brand reputation, elevate user experience, and expand your revenue streams.',
    items: [
      'Product Management',
      'Inventory Tracking',
      'Multi-currency Support',
      'SEO Optimization',
      'Mobile-First Design',
      'One-Click Checkout',
      'Customer Reviews',
      'Secure Payments',
      'Order Management',
      'Discount & Coupons',
      'Email Marketing',
      'Sales Analytics',
    ],
  },
  excellence: {
    title: 'Collaborative Excellence',
    subtitle:
      "At RojrzTech, we prioritize collaboration to ensure the best outcomes for our clients. We maintain constant communication, refining your store until you're completely satisfied.",
    cards: [
      {
        icon: '🎨',
        title: 'Stunning Storefront Design',
        description:
          'Our designers create visually compelling storefronts that reflect your brand identity and drive customer engagement.',
      },
      {
        icon: '🔒',
        title: 'Secure & Reliable Transactions',
        description:
          'We implement industry-standard security protocols to protect your customers\' data and ensure safe transactions.',
      },
      {
        icon: '📱',
        title: 'Mobile-First Commerce',
        description:
          'Our ecommerce solutions are built mobile-first, ensuring a seamless shopping experience on every device and screen size.',
      },
      {
        icon: '⚡',
        title: 'Lightning-Fast Performance',
        description:
          'We optimize every aspect of your store for speed, reducing load times and ensuring a smooth shopping experience.',
      },
      {
        icon: '📈',
        title: 'Built for Scalability',
        description:
          'Your store grows with your business. We build scalable architectures that handle increasing traffic and product catalogues.',
      },
      {
        icon: '🚀',
        title: 'SEO-Ready from Day One',
        description:
          'Every store we build is SEO-optimized from the ground up, helping you rank higher and attract more organic traffic.',
      },
    ],
  },
  relatedServices: ALL_SERVICES.filter((s) => s.href !== '/services/cms-ecommerce'),
};

const CmsEcommerce = () => <ServicePageTemplate pageData={pageData} />;
export default CmsEcommerce;
